import React from 'react';
import { useNavigate } from 'react-router-dom';
import './MenuCard.css';

type Props = {
  title: string;
  description: string;
  icon: string;
  path: string;
  comingSoon?: boolean;
  isAdmin?: boolean;
  index?: number;
  basePath?: string;
};

const MenuCard = ({ title, description, icon, path, comingSoon, isAdmin, index = 0, basePath = '' }: Props) => {
  const navigate = useNavigate();
  const isDisabled = comingSoon && !isAdmin;
  const handleClick = () => { if (!isDisabled) navigate(`${basePath}${path}`); };

  return (
    <div
      className={`menu-card ${isDisabled ? 'coming-soon' : ''}`}
      style={{ '--card-delay': `${index * 50}ms` } as React.CSSProperties}
      onClick={handleClick}
    >
      <div className="card-icon">
        <span className="material-symbols-outlined">{icon}</span>
      </div>
      <div className="card-content">
        <h3>{title}{comingSoon && <span className="card-coming-soon-label">Coming Soon</span>}</h3>
        <p>{description}</p>
      </div>
    </div>
  );
};

export default MenuCard;
